import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import sobreImg from "../../assets/images/sobrefotomenor.webp";

const Sobre = () => {
  return (
    <section id="sobre" className="sobre-section min-vh-100">
      <div className="container">
        <div className="row align-items-center">
          {" "}
          {/* Esquerda: Imagem */}
          <div className="col-md-6 image-section">
            <InViewComponent delay={0.1}>
              <img
                src={sobreImg}
                alt="Foto representativa"
                className="img-fluid rounded"
              />{" "}
              <p className="text-start mt-3 mb-0 fw-bold text-muted">
                Pastora Presidente Rita Platenkamp
              </p>
            </InViewComponent>
          </div>
          {/* Direita: Título e Texto */}
          <div className="col-md-6 text-section">
            <InViewComponent delay={0.2}>
              <h2 className="titulo-sobre">Igreja Evangélica Casa de Oração</h2>
            </InViewComponent>
            <InViewComponent delay={0.3}>
              <p>
                <strong>
                  A Igreja Evangélica Casa de Oração - Pastora Presidente
                  Rita Platenkamp
                </strong>{" "}
                tem como maior objetivo{" "}
                <strong>
                  proclamar o santo evangelho do Senhor Jesus Cristo
                </strong>
                , em cumprimento ao 'IDE' de Cristo Jesus, nosso Senhor e
                salvador das nossas vidas. Nossa fundação está situada em
                Hengelo-NL, e nosso endereço se localiza neste mesmo lugar.
              </p>
            </InViewComponent>
            <InViewComponent delay={0.4}>
              <p>
                Como uma instituição cristã e religiosa, nossa igreja é um
                organismo vivo, baseado na{" "}
                <strong>Santa Palavra de Deus, a Bíblia Sagrada</strong>, e sem
                fins lucrativos. Seguimos obedecendo a ordem de Jesus Cristo,
                conforme está escrito no livro de Marcos, capítulo 16, versículo
                15. Proclamamos com todas as nossas forças essa missão, pois
                somos a Igreja e Jesus Cristo é nosso guia maior nos céus e na
                terra.
              </p>
            </InViewComponent>
            <InViewComponent delay={0.5}>
              <p>
                Além disso, realizamos{" "}
                <strong>obras sociais na nossa comunidade</strong>, contribuindo
                para o bem-estar e o desenvolvimento espiritual e social dos
                nossos irmãos. <strong>Amém!!</strong>
              </p>
            </InViewComponent>
          </div>
        </div>
      </div>
    </section>
  );
};

const InViewComponent = ({ children, delay }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true, // Configurado para animar apenas uma vez
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      transition={{ duration: 0.6, delay, ease: "easeInOut" }}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
      }}
    >
      {children}
    </motion.div>
  );
};

export default Sobre;
